export default __webpack_public_path__ + "static/media/login.6ce8c7f3.png";